import React from "react";
import { withTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import cskart1 from "../../assets/cscart/cs-kart1.png";
import cskart2 from "../../assets/cscart/cs-kart2.png";
import cskart3 from "../../assets/cscart/cs-kart3.png";
import cskart4 from "../../assets/cscart/cs-kart4.png";
import cskart5 from "../../assets/cscart/cs-kart5.png";
import cskart6 from "../../assets/cscart/cs-kart6.png";
import cskart7 from "../../assets/cscart/cs-kart7.png";
import cskart8 from "../../assets/cscart/cs-kart8.png";
import cskart9 from "../../assets/cscart/cs-kart9.png";
import cskart10 from "../../assets/cscart/cs-kart10.png";
import { Theme, Typography } from "@mui/material";
import { colors } from "../../theme/theme";

export const CsCartEn = () => {
  const navigate = useNavigate();
  const Styles = withTheme(styled.div`
    @media screen and (min-width: 1200px) {
      .sidebar {
        position: sticky;
        top: 0;
        bottom: 0;
        left: 0;
        border-right: 1px solid gray;
        width: 250px;
      }
    }
    .sidebar-link-item {
      padding-top: 3rem;
      padding-right: 2rem;
      padding-left: 1rem;
      font-size: 14pt;
    }

    @media (max-width: 1200px) {
      .hidden {
        display: none;
      }
    }
    a {
      font-family: ${({ theme }: { theme: Theme }) =>
        theme.typography.fontFamily};
      text-decoration: none;
      color: ${colors.secondary};
      font-weight: 500;
      -webkit-text-decoration: underline #f1bfdf 2px;
      text-decoration: underline #f1bfdf 2px;
      text-underline-position: under;
    }
    .icon-cont {
      position: absolute;
      top: 76%;
      left: 15%;
      transform: rotate(180deg);
      width: 80px;
      height: 100px;
      cursor: pointer;
    }
    ol {
      padding-left: 32px;
    }
    li {
      text-align: left;
    }
    p {
      text-align: left;
      padding-left: 16px;
    }
    aside ul {
      padding-left: 16px;
    }
    img {
      max-width: 100%; /* Ensure images don't exceed the container width */
      height: auto; /* Maintain aspect ratio */
      margin: 0 auto; /* Center images horizontally if needed */
      display: block; /* Remove default image inline alignment */
    }
  `);
  return (
    <Styles>
      <div className="container d-flex flex-row">
        <div className="w-75 position-relative">
          <aside className="sidebar hidden">
            <ul className="list-inside list-unstyled mt-3">
              <li>
                <a
                  className="h4"
                  href="https://boxnow.gr/en/diy/eshops/plugins/cs-cart"
                >
                  Cs-Cart
                </a>
                <ul className="list-inside list-unstyled">
                  <li className="sidebar-link-item">
                    <a href="#1">Setup instructions</a>
                  </li>
                  <li className="sidebar-link-item">
                    <a href="#2">Create Voucher </a>
                  </li>
                  <li className="sidebar-link-item">
                    <a href="#3">Print Voucher </a>
                  </li>
                  <li className="sidebar-link-item pb-3">
                    <a href="#4">Support</a>
                  </li>
                </ul>
              </li>
              <li className="sidebar-link-item pb-3">
                <span className="h5 d-flex align-items-center">
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/eshops");
                    }}
                  >
                    Go back
                  </a>
                </span>
              </li>
            </ul>
          </aside>
        </div>
        <div>
          <h2>Cs-Cart</h2>
          <div className="mt-5">
            <span>For downloading and plugin support, contact: </span>
            <a href="https://wisebit.gr/#contact" target="_blank">
              wisebit
            </a>
          </div>
          <div className="mt-5">
            <span>
              For further information please contact the email address:
              <a href="mailto: sales@wisebit.gr">sales@wisebit.gr</a>
              or by phone: <a href="tel: 215 215 0110">215 215 0110</a>
            </span>
          </div>
          <h3 className="mt-5">How to use</h3>
          <h4 className="mt-5" id="1">
            Setup instructions
          </h4>

          <p>
            After the installation, you need to register the user info you have
            received from BOX NOW in the Plugin menu accordingly.
          </p>

          <p>
            <span className="bolder">Note</span>: In the Warehouses menu you can
            register multiple pickup points in the form: 4068 [Main Warehouse]
            where 4068 is the pickup id point which you will receive from BOX
            NOW while inside the bracket you type the label with which the pick
            up point will be recognized in the voucher creation process..
          </p>

          <img className="mt-5 mb-5" src={cskart1} />

          <p>In Settings menu you can adjust:</p>
          <ol type="A">
            <li>COD from the already installed ones</li>
            <li>
              Order status changes which will occur when creating a voucher
            </li>
            <li>The field witch generates the notes for the voucher</li>
            <li>
              Select whether Auto Deliveries will be created when a new order is
              received
            </li>
          </ol>

          <img className="mt-5 mb-5" src={cskart2} />

          <p>
            Finally, in the Profile Fields Mapping of the plugin, you need to
            map the fields of the shipment address so you can match the
            correlating Voucher fields.
          </p>

          <img className="mt-5 mb-5" src={cskart3} />

          <p>
            <span>Use</span>
            Through an order, you will create a delivery as always through
            CS-Cart by clicking Create Detailed Delivey
          </p>

          <img className="mt-5 mb-5" src={cskart4} />

          <p>
            A popup will occur in which, a BOX NOW voucher with the accordingly
            fields will be shown:
          </p>

          <img className="mt-5 mb-5" src={cskart5} />

          <ul className="list-inside">
            <li>
              Shipping method : Boxnow (you need to manually open it previously
              in the Shipping Methods)
            </li>
            <li>Tracking Number : Leave blank, it will be auto-generated</li>
            <li>Carrier : Boxnow</li>
            <li>
              Check “Create Shipments according to products quantity” only if
              order contains more than one packages
            </li>
            <li>
              Warehouse: Corresponding pick up point from which BOX NOW will
              receive the package
            </li>
            <li>
              Select “Create Voucher “ if you want to immediately create the
              voucher.
            </li>
            <li>
              In Comments you can write Delivery notes, provided you have
              already chosen to show such info from the voucher
            </li>
          </ul>

          <h4 className="mt-5" id="2">
            Create Voucher
          </h4>

          <p className="mt-3">
            By clicking Create, you will see the order delivery
          </p>

          <img className="mt-5 mb-5" src={cskart6} />

          <p>By selecting the cog icon in BOX NOW delivery: Create Voucher</p>

          <p>
            A voucher will be created and a green popup will occur, informing
            you, while it’s number will be also shown in the voucher column
          </p>

          <img className="mt-5 mb-5" src={cskart7} />

          <p>
            Voucher number is a link to the tracking page of the order from your
            shop
          </p>

          <img className="mt-5 mb-5" src={cskart8} />

          <h4 className="mt-5" id="3">
            Print Voucher
          </h4>

          <p>
            From the Delivery cog icon you can print or delete the voucher as
            well as inform your customer about the voucher number
          </p>

          <img className="mt-5 mb-5" src={cskart9} />

          <p>
            Through the order you have the option, provided BOX NOW has given
            you permission and no voucher has been created for the order, to
            change customer’s pickup point, by clicking the prompt next to
            locker ID
          </p>

          <img className="mt-5 mb-5" src={cskart10} />

          <p>Insert the new Locker ID provided by BOX NOW and save the order</p>

          <p>
            The Delivery Point description will change and an e-mail will be
            sent to your client regarding this change.
          </p>

          <h4 className="mt-5" id="4">
            Notes:
          </h4>
          <ol>
            <li>Testing plugin with stage Api keys</li>
            <li>
              Select stage locker: Aegean ΜΕΤΡΟ Ελαιώνας, locker id: 9, Address:
              IEPA OΔOΣ 116, 10447
            </li>
            <li>
              When a new order is completed we will automatically send you a PDF
              shipping label.
            </li>
          </ol>

          <h4 className="mt-5">Get Support</h4>
          <p>
            For any questions regarding the above please call at: +30 2111005330
            or email us at:
            <a href="mailto: ict@boxnow.gr">ict@boxnow.gr</a>
          </p>
        </div>
      </div>
    </Styles>
  );
};
